import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { FlexRow, SearchInput } from "@similarweb/ui-components";

import { LIST_HEIGHT } from "./constants";

const { carbon, sky } = colorsPalettes;

export const ListContainer = styled.div`
    padding: 8px;
    overflow-y: auto;
    background-color: ${sky[100]};
    border-radius: 6px;
    box-shadow: 0 3px 6px 0 rgba(14, 30, 62, 0.08);
    min-height: ${LIST_HEIGHT}px;
`;

const ListItem = styled(FlexRow)`
    box-sizing: border-box;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    height: 78px;
    border: 1px solid ${carbon[50]};
    border-radius: 8px;
    background-color: ${carbon[0]};
    cursor: pointer;
`;

const ListItemName = styled.p`
    font-size: 16px;
    font-weight: 600;
    color: ${carbon[500]};
`;

export const ListHeader = styled(FlexRow)`
    box-sizing: border-box;
    width: 100%;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
`;

export const StyledSearchInput = styled(SearchInput)`
    margin: 0;
    padding: 0;
    margin-left: auto;
    width: 320px;

    & .biRney {
        padding-top: 5px;
    }

    & input.SearchInput {
        width: calc(100% - 55px);
        max-width: 100%;
        margin: 0;
        padding: 8px 2px 8px 50px;
    }

    & input:disabled {
        width: calc(100% - 20px);
    }

    & div {
        &:has(.SWReactIcons[data-automation-icon-name="search"]) {
            top: 9px;
        }

        &:has(.SWReactIcons[data-automation-icon-name="clear"]) {
            top: 14px;
        }
    }
`;
